import { render, staticRenderFns } from "./SlicePeople.vue?vue&type=template&id=42edba3a&scoped=true"
import script from "./SlicePeople.vue?vue&type=script&lang=js"
export * from "./SlicePeople.vue?vue&type=script&lang=js"
import style0 from "./SlicePeople.vue?vue&type=style&index=0&id=42edba3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42edba3a",
  null
  
)

export default component.exports